import CardReaderScreen from './CardReaderScreen';

export default CardReaderScreen;
